import zod from "zod";

import { singleRecipientValidationSchema } from "./SingleRecipientValidationSchema";

export const selectRecipientsFormValidationSchema = zod.object({
  recipients: zod.array(singleRecipientValidationSchema),
});

export type SelectRecipientsFormData = zod.infer<typeof selectRecipientsFormValidationSchema>;
